/**
 * 登录/注册/找回密码弹窗
 * - 打开：[data-auth-modal-open] 触发（header 账户图标 / 移动端抽屉账户链接，未登录时输出）
 * - 提交：原生表单提交（非 AJAX）。校验通过后不拦截，由 Shopify captcha-bootstrap 脚本托管
 *   form_key/hCaptcha 令牌流程；登录/注册成功后按表单 return_to 跳回发起页，
 *   失败由 Shopify 渲染 /account/login、/account/register 并展示服务端错误（与网页版一致）
 */
(function () {
  function initAuthModal() {
    var modal = document.getElementById('AuthModal');
    if (!modal) return;

    var strings = {
      invalidEmail: modal.dataset.invalidEmail || 'Please enter a valid email address.',
      mismatch: modal.dataset.credentialsMismatch || 'Email and password do not match.',
      termsMessage: modal.dataset.termsMessage || ''
    };
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var GA_PAGE = 'Login&RegisterPage'; // [埋点-20260827] 弹窗与网页版共用 category
    var lastTrigger = null;

    function ga(type, label) {
      if (typeof gaReportEvent === 'function') gaReportEvent(type, GA_PAGE, label);
    }

    /* ---------------- 开关与面板切换 ---------------- */

    function setHeaderOffset() {
      var header = document.getElementById('shopify-section-header');
      if (header) modal.style.setProperty('--auth-header-height', header.offsetHeight + 'px');
    }

    function openModal(panel) {
      lastTrigger = document.activeElement;
      setHeaderOffset();
      switchPanel(panel || 'login');
      modal.classList.add('is-open');
      /* 与其他弹窗一致：uxUtils.bodyNoScroll 给 html 加 noscroll 并补偿滚动条宽度；
         uxUtils 为顶层 const 词法绑定，不挂 window，需用 typeof 探测 */
      if (typeof uxUtils !== 'undefined' && typeof uxUtils.bodyNoScroll === 'function') {
        uxUtils.bodyNoScroll();
      } else {
        document.body.classList.add('overflow-hidden');
      }
      ga('pageview', 'Login&RegisterPage_View_20260703');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      if (typeof uxUtils !== 'undefined' && typeof uxUtils.bodyClearNoScroll === 'function') {
        uxUtils.bodyClearNoScroll();
      } else {
        document.body.classList.remove('overflow-hidden');
      }
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    function switchPanel(name) {
      modal.querySelectorAll('[data-auth-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.authPanel !== name;
      });
      clearErrors(modal);
      var dialog = modal.querySelector('.auth-modal__dialog');
      if (dialog) dialog.scrollTop = 0;
    }

    /* ---------------- 错误展示（仅前端校验用；服务端错误由 /account/login、/account/register 页面展示） ---------------- */

    function showError(input, message) {
      if (!input) return;
      input.classList.add('auth-form__input--error');
      var field = input.closest('.auth-form__field');
      var err = field && field.querySelector('[data-auth-error]');
      if (err) {
        err.textContent = message;
        err.hidden = false;
      }
    }

    function clearErrors(scope) {
      scope.querySelectorAll('.auth-form__input--error').forEach(function (input) {
        input.classList.remove('auth-form__input--error');
      });
      scope.querySelectorAll('[data-auth-error]').forEach(function (err) {
        err.hidden = true;
        err.textContent = '';
      });
    }

    /* ---------------- 死按钮兜底 ----------------
       Shopify captcha 脚本的提交拦截逻辑：hCaptcha 绑定成功 -> preventDefault + 重新提交；
       绑定失败（如 hcaptcha 资源不可达）-> 只 preventDefault、永不提交，按钮零反馈。
       利用“页面开始跳转会卸载并销毁计时器”的特性：5 秒后页面还在 = 提交被吞，强制 form.submit() 兜底。
       form.submit() 是编程式提交，不触发 submit 事件，可绕开脚本拦截直达服务端 */
    function armNativeFallback(form) {
      setTimeout(function () {
        form.submit();
      }, 5000);
    }

    /* ---------------- 表单引用 ---------------- */

    var loginForm = modal.querySelector('[data-auth-form="login"]') || modal.querySelector('#AuthModalLoginForm');

    /* ---------------- 注册条款（勾选拦截 + 国家默认勾选，同注册页逻辑） ---------------- */

    var registerForm = modal.querySelector('[data-auth-form="register"]') || modal.querySelector('#AuthModalRegisterForm');
    var termsCheckbox = modal.querySelector('#AuthModal-RegisterTerms');
    var termsCover = modal.querySelector('[data-auth-terms-cover]');

    function syncTermsCover() {
      if (termsCover && termsCheckbox) termsCover.hidden = termsCheckbox.checked;
    }

    function toastTerms() {
      /* uxUtils 为顶层 const 词法绑定，不挂 window，需用 typeof 探测 */
      if (typeof uxUtils !== 'undefined' && typeof uxUtils.toast === 'function') {
        uxUtils.toast({ message: strings.termsMessage });
      }
    }

    if (termsCheckbox && termsCover) {
      termsCover.addEventListener('click', toastTerms);
      termsCheckbox.addEventListener('change', syncTermsCover);

      var defaultTermsAgreeCountry = {
        AU: true, BE: false, CA: true, DK: false, FR: false, DE: false,
        HU: false, IT: false, NO: false, JP: true, US: true
      };
      var country = (window.Shopify && Shopify.country) || 'US';
      termsCheckbox.checked = defaultTermsAgreeCountry[country] || false;
      syncTermsCover();
    }

    var marketingCheckbox = modal.querySelector('#AuthModal-RegisterMarketing');
    if (marketingCheckbox) {
      marketingCheckbox.addEventListener('change', function () {
        if (marketingCheckbox.checked) ga('click', 'SubscribeButton_Click_20260703');
      });
    }

    /* ---------------- 找回密码表单引用 ---------------- */

    var recoverForm = modal.querySelector('[data-auth-form="recover"]') || modal.querySelector('#AuthModalRecoverForm');

    /* ---------------- 提交拦截（document 捕获阶段） ----------------
       Shopify hCaptcha provider 绑定表单后会在 form 上挂目标阶段 submit 监听：
       preventDefault + challenge + 强制提交，且不检查 defaultPrevented ——
       与我们在同元素上 preventDefault 拦不住它（preventDefault 不阻止其他监听器执行）。
       document 捕获阶段先于目标阶段执行，校验失败时 preventDefault + stopPropagation，
       provider 监听器收不到事件，challenge 不会启动，真正拦死提交（点击与 Enter 均覆盖）。
       校验通过则放行，hCaptcha 流程与 5s 死按钮兜底维持原样 */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form !== loginForm && form !== registerForm && form !== recoverForm) return;

      clearErrors(form);

      function block() {
        e.preventDefault();
        e.stopPropagation();
      }

      if (form === loginForm) {
        // [埋点-20260827] 登录按钮：点击即上报（无论前端校验是否通过）
        ga('click', 'LoginButton_Click_20260703');
        var loginEmail = form.querySelector('#AuthModal-CustomerEmail');
        var loginPassword = form.querySelector('#AuthModal-CustomerPassword');
        if (!EMAIL_RE.test(loginEmail.value.trim())) {
          block();
          showError(loginEmail, strings.invalidEmail);
          return;
        }
        if (!loginPassword.value) {
          block();
          showError(loginPassword, strings.mismatch);
          return;
        }
      } else if (form === registerForm) {
        // [埋点-20260827] 注册按钮：点击即上报（无论前端校验是否通过）
        ga('click', 'RegisterButton_Click_20260703');
        var regEmail = form.querySelector('#AuthModal-RegisterEmail');
        var regPassword = form.querySelector('#AuthModal-RegisterPassword');
        if (termsCheckbox && !termsCheckbox.checked) {
          block();
          toastTerms();
          return;
        }
        if (!EMAIL_RE.test(regEmail.value.trim())) {
          block();
          showError(regEmail, strings.invalidEmail);
          return;
        }
        if (!regPassword.value) {
          block();
          showError(regPassword, strings.mismatch);
          return;
        }
      } else {
        // [埋点-20260827] 找回密码提交按钮：点击即上报（无论前端校验是否通过）
        ga('click', 'SubmitButton_Click_20260703');
        var recoverEmail = form.querySelector('#AuthModal-RecoverEmail');
        if (!EMAIL_RE.test(recoverEmail.value.trim())) {
          block();
          showError(recoverEmail, strings.invalidEmail);
          return;
        }
      }

      // 校验通过：不拦截，事件继续传播到 hCaptcha provider 走 challenge 流程，
      // 登录/注册成功后按表单 return_to 跳回发起页，失败由 /account/login、/account/register 展示服务端错误
      armNativeFallback(form);
    }, true);

    /* ---------------- 事件委托 ---------------- */

    // 打开弹窗（header 图标 / 移动端抽屉入口）
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-auth-modal-open]');
      if (!trigger) return;
      e.preventDefault();
      // 移动端菜单抽屉内触发时先关闭抽屉：必须走 MenuDrawer.closeMenuDrawer
      // 一并移除 menu-opening 类（遮罩 .menu-opening .header__icon--menu::before 依赖该类），
      // 只 removeAttribute('open') 会导致抽屉关了但遮罩残留
      var drawer = trigger.closest('details');
      if (drawer) {
        var drawerEl = drawer.closest('header-drawer') || drawer.closest('menu-drawer');
        if (drawerEl && typeof drawerEl.closeMenuDrawer === 'function') {
          drawerEl.closeMenuDrawer(e, drawer.querySelector('summary'));
        } else {
          drawer.removeAttribute('open');
        }
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop', 'overflow-hidden-mobile');
      }
      openModal(trigger.dataset.authModalOpen || 'login');
    });

    // 弹窗内：面板切换 / 关闭
    modal.addEventListener('click', function (e) {
      var gotoBtn = e.target.closest('[data-auth-goto]');
      if (gotoBtn) {
        if (gotoBtn.dataset.authGoto === 'recover') ga('click', 'ForgotPasswordButton_Click_20260703');
        switchPanel(gotoBtn.dataset.authGoto);
        return;
      }
      if (e.target.closest('[data-auth-close]')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    // 密码可见性切换
    modal.querySelectorAll('[data-auth-password-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var use = btn.querySelector('use');
        if (!input || !use) return;
        var show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        use.setAttribute('href', show ? '#pcvisible' : '#pc-invisible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAuthModal);
  } else {
    initAuthModal();
  }
})();
